function AuthedView() {
  return (
    <>
      <div>Authed</div>
    </>
  );
}

export default AuthedView;
